import angular from 'angular';

import common from './common';
import authorised from './authorised';
import guest from './guest';
import planner from './planner';

import plannerRoutes from './planner/routes';

const components = angular.module('components', [
    common,
    guest,
    authorised,
    planner
]);

components.config(plannerRoutes);

export default components.name;



// WEBPACK FOOTER //
// ./src/js/components/index.js